document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('main-header');
    const sortFilterDesktop = document.querySelector('.sort-and-filter-desktop');
    const sortFilterMobile = document.querySelector('.sort-and-filter-mobile');
    const sortFilterMobileSticky = document.querySelector('.sort-and-filter-mobile-sticky');
    const firstProductGrid = document.querySelector('.collection-product-grid-section .collection-product-grid');

    if (header && sortFilterDesktop && firstProductGrid && window.innerWidth >= 1024) {
        let sortFilterHeight = sortFilterDesktop.offsetHeight;
        const finalTop = 640;

        let initialGridTop = null;

        function getInitialGridPosition() {
            if (initialGridTop === null) {
                const gridRect = firstProductGrid.getBoundingClientRect();
                initialGridTop = gridRect.top + window.pageYOffset;
            }
            return initialGridTop;
        }

        function setupDesktopSortFilter() {
            const headerRect = header.getBoundingClientRect();

            const gridAbsoluteTop = getInitialGridPosition();
            const startOffset = 0;

            sortFilterDesktop.style.position = 'absolute';
            sortFilterDesktop.style.left = `${headerRect.left}px`;
            sortFilterDesktop.style.width = `${headerRect.width}px`;
            sortFilterDesktop.style.zIndex = '40';
            sortFilterDesktop.style.top = `${gridAbsoluteTop + startOffset}px`;

        }

        function updateDesktopSortFilterPosition() {
            const gridRect = firstProductGrid.getBoundingClientRect();
            const headerRect = header.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const scrollY = window.pageYOffset;
            const gridAbsoluteTop = getInitialGridPosition();
            const startOffset = 0;

            if (gridRect.top > viewportHeight) {
                requestAnimationFrame(() => {
                    sortFilterDesktop.style.position = 'absolute';
                    sortFilterDesktop.style.top = `${gridAbsoluteTop + startOffset}px`;
                    sortFilterDesktop.style.left = `${headerRect.left}px`;
                    sortFilterDesktop.style.width = `${headerRect.width}px`;
                });
                return;
            }

            const absolutePositionInViewport = (gridAbsoluteTop + startOffset) - scrollY;

            const gridEntryScrollY = gridAbsoluteTop - viewportHeight;
            const scrollSinceEntry = Math.max(0, scrollY - gridEntryScrollY);

            const animationDistance = sortFilterHeight + 200;
            const scrollProgress = Math.max(0, Math.min(1, scrollSinceEntry / animationDistance));

            const startTop = absolutePositionInViewport;
            const travelDistance = startTop - finalTop;
            const currentTop = startTop - (scrollProgress * travelDistance);

            requestAnimationFrame(() => {
                sortFilterDesktop.style.position = 'fixed';
                sortFilterDesktop.style.top = `${Math.max(finalTop, currentTop)}px`;
                sortFilterDesktop.style.left = `${headerRect.left}px`;
                sortFilterDesktop.style.width = `${headerRect.width}px`;
            });
        }

        setupDesktopSortFilter();

        requestAnimationFrame(() => {
            updateDesktopSortFilterPosition();
        });

        let desktopTicking = false;
        window.addEventListener('scroll', () => {
            if (window.innerWidth >= 1024 && !desktopTicking) {
                window.requestAnimationFrame(() => {
                    updateDesktopSortFilterPosition();
                    desktopTicking = false;
                });
                desktopTicking = true;
            }
        }, { passive: true });

        let resizeTimeout;
        window.addEventListener('resize', () => {
            if (window.innerWidth < 1024) {
                return;
            }

            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                requestAnimationFrame(() => {
                    initialGridTop = null;
                    sortFilterHeight = sortFilterDesktop.offsetHeight;
                    setupDesktopSortFilter();
                    updateDesktopSortFilterPosition();
                });
            }, 150);
        });
    }

    if (!(sortFilterMobile && sortFilterMobileSticky)) {
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                requestAnimationFrame(() => {
                    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                        sortFilterMobileSticky.classList.remove('opacity-0', 'invisible', 'translate-y-4');
                        sortFilterMobileSticky.classList.add('opacity-100', 'visible', 'translate-y-0');
                    } else {
                        sortFilterMobileSticky.classList.add('opacity-0', 'invisible', 'translate-y-4');
                        sortFilterMobileSticky.classList.remove('opacity-100', 'visible', 'translate-y-0');
                    }
                });
            });
        },
        {
            threshold: 0,
            rootMargin: '0px'
        }
    );

    let isObserving = false;
    if (window.innerWidth < 1024) {
        observer.observe(sortFilterMobile);
        isObserving = true;
    }

    let mobileResizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(mobileResizeTimeout);
        mobileResizeTimeout = setTimeout(() => {
            const isMobile = window.innerWidth < 1024;

            if (isMobile && !isObserving) {
                observer.observe(sortFilterMobile);
                isObserving = true;
            } else if (!isMobile && isObserving) {
                observer.disconnect();
                isObserving = false;
                requestAnimationFrame(() => {
                    sortFilterMobileSticky.classList.add('opacity-0', 'invisible', 'translate-y-4');
                    sortFilterMobileSticky.classList.remove('opacity-100', 'visible', 'translate-y-0');
                });
            }
        }, 150);
    });
});